import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    compose,
    setDisplayName,
} from 'recompose';
import { withTracker } from 'components/Tracker';

import { BasicMain, injectIntl } from 'components';
import immutableToJS from 'helpers/immutableToJS';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import MailIcon from '@material-ui/icons/Mail';
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import { Col, Row } from 'reactstrap';


class ContactUs extends Component {
    static propTypes = {
        formatMessage: PropTypes.func.isRequired,
    };
    render() {
        const { formatMessage } = this.props;

        return (
            <div className="contact-page">
                <BasicMain>
                    <Typography variant="h4" align="center" color="textPrimary" component="h1">
                        {formatMessage('Contact Us')}
                    </Typography>
                    <Card className="contact-info-container">
                        <CardContent>
                            {/* email */}
                            <Row style={{ marginBottom: '30px' }}>
                                <Col xs="2">
                                    <MailIcon className="contact-icon" />
                                </Col>
                                <Col xs="10" className="contact-info">
                                    <span> Email: </span>
                                    <br />
                                    <span> team@freshr.com</span>
                                </Col>
                            </Row>

                            {/* phone */}
                            <Row style={{ marginBottom: '30px' }}>
                                <Col xs="2">
                                    <ContactPhoneIcon className="contact-icon" />
                                </Col>
                                <Col xs="10" className="contact-info">
                                    <span> Phone: </span>
                                    <br />
                                    <span> (415)275-4921 </span>
                                </Col>
                            </Row>

                            {/* open time */}
                            <Row style={{ marginBottom: '30px' }}>
                                <Col xs="2">
                                    <AccessTimeIcon className="contact-icon" />
                                </Col>
                                <Col xs="10" className="contact-info">
                                    <span> Operation time: </span>
                                    <br />
                                    <span> 8:00am - 8:00pm PST, Mon-Sun </span>
                                </Col>
                            </Row>
                        </CardContent>
                    </Card>

                </BasicMain>
            </div>
        );
    }
}


export default compose(
    setDisplayName('ContactUs'),
    injectIntl,
    immutableToJS,
    withTracker,
)(ContactUs);
